import { featureToggles } from './feature-toggles'

export const pathOverrideConfig = {
  checkForBloomreachPathOverride: featureToggles.isPdpBloomreachPathOverrideEnabled,
}
